module.exports = ".top-margin {\n  margin-top: 48px; }\n\n.fix-top {\n  position: fixed;\n  left: 100px;\n  z-index: 3;\n  width: 100%; }\n\n.container {\n  padding-left: 115px; }\n\n.conf-section {\n  padding-left: 115px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/account/vendor-register/vendor-register.component.scss
// module id = ./src/app/pages/account/vendor-register/vendor-register.component.scss
// module chunks = main